import { List } from "immutable";
import { handleActions } from "redux-actions";
import { GLOBAL } from "constants/action-types";

interface IState {
    error: any;
    errorModal: any;
    product: any;
    products: any;
    productsModal?: any;
    nextPageQuery?: string[];
    nextPageQueryModal?: string[];
    isFetching: boolean;
    isFetchingModal: boolean;
}

const initialState: any = {
    error: undefined,
    errorModal: undefined,
    product: undefined,
    products: undefined,
    productsModal: undefined,
    nextPageQueryModal: undefined,
    nextPageQuery: undefined,
    isFetching: false,
    isFetchingModal: false,
};

export const globalProducts = handleActions(
    {
        [GLOBAL.PRODUCT.FETCH.COMPLETED]: (state: IState, { error, payload }: any): IState => {
            if (error) {
                return {
                    ...state,
                    error: payload,
                };
            }
            return {
                ...state,
                product: payload,
            };
        },
        [GLOBAL.PRODUCTS.FETCH.START]: (state: IState, { payload }): IState => {
            return {
                ...state,
                [payload.modal ? "errorModal" : "error"]: undefined,
                [payload.modal ? "productsModal" : "products"]: undefined,
                [payload.modal ? "nextPageQueryModal" : "nextPageQuery"]: undefined,
                [payload.modal ? "isFetchingModal" : "isFetching"]: true,
            };
        },
        [GLOBAL.PRODUCTS.FETCH.NEXT]: (state: IState, { payload }): IState => {
            return {
                ...state,
                [payload.modal ? "isFetchingModal" : "isFetching"]: true,
            };
        },
        [GLOBAL.PRODUCTS.FETCH.COMPLETED]: (state: IState, { error, payload }: any): IState => {
            if (error) {
                return {
                    ...state,
                    [payload.modal ? "errorModal" : "error"]: payload.error,
                    [payload.modal ? "nextPageQueryModal" : "nextPageQuery"]: undefined,
                    [payload.modal ? "isFetchingModal" : "isFetching"]: false,
                };
            }
            const products = (payload.modal ? state.productsModal : state.products) || List();
            return {
                ...state,
                [payload.modal ? "isFetchingModal" : "isFetching"]: false,
                [payload.modal ? "productsModal" : "products"]: payload.results
                    ? products.concat(payload.results)
                    : payload.results,
                [payload.modal ? "nextPageQueryModal" : "nextPageQuery"]: payload.nextPageQuery,
            };
        },
        [GLOBAL.PRODUCTS.VARIANTS.FETCH.COMPLETED]: (state: IState, { error, payload }: any): IState => {
            if (error) {
                return {
                    ...state,
                    [payload.modal ? "errorModal" : "error"]: payload.error,
                    [payload.modal ? "nextPageQueryModal" : "nextPageQuery"]: undefined,
                    [payload.modal ? "isFetchingModal" : "isFetching"]: false,
                };
            }
            const products = (payload.modal ? state.productsModal : state.products) || List();
            return {
                ...state,
                [payload.modal ? "isFetchingModal" : "isFetching"]: false,
                [payload.modal ? "productsModal" : "products"]: payload.results
                    ? products.concat(payload.results)
                    : payload.results,
                [payload.modal ? "nextPageQueryModal" : "nextPageQuery"]: payload.nextPageQuery,
            };
        },
        [GLOBAL.PRODUCTS.RESET]: (state: IState, { payload }): IState => {
            return {
                ...state,
                [payload.modal ? "errorModal" : "error"]: undefined,
                [payload.modal ? "isFetchingModal" : "isFetching"]: false,
                [payload.modal ? "nextPageQueryModal" : "nextPageQuery"]: undefined,
                [payload.modal ? "productsModal" : "products"]: undefined,
            };
        },
    },
    initialState
);
